import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt, getDoc } from '@angular/fire/firestore';

import { map } from 'rxjs/operators';

import { Observable, BehaviorSubject } from 'rxjs';

import { Theme, Episode } from '../classes/index';

@Injectable()
export class ThemeService {

	/*themes: Theme[] = [];
	episodes: Episode[] = [];*/

	themeBase: Theme[] = [];
	episodeBase: Episode[] = [];

	private _themes: BehaviorSubject<Theme[]>;
  	public themes: Observable<Theme[]>;
	private _episodes: BehaviorSubject<Episode[]>;
	public episodes: Observable<Episode[]>;

	constructor(private firestore: Firestore) {
		console.log('ThemeService initialization...');
		this._themes = <BehaviorSubject<[]>>new BehaviorSubject([]);
      	this.themes = this._themes.asObservable();
		this._episodes = <BehaviorSubject<[]>>new BehaviorSubject([]);
		this.episodes = this._episodes.asObservable();

		this.listThemes()
		.subscribe(themes => {
			this.themeBase = themes.sort((a, b) => {
				if (a.name['fr'] > b.name['fr']) return 1;
				else if (a.name['fr'] < b.name['fr']) return -1;
				else return 0;
			});
			this._themes.next(this.themeBase);
		});
		this.listAllEpisodes()
		.subscribe(episodes => {
			this.episodeBase = episodes.sort((a, b) => {
				if (a.name['fr'] > b.name['fr']) return 1;
				else if (a.name['fr'] < b.name['fr']) return -1;
				else return 0;
			});
			this._episodes.next(this.episodeBase);
		});
	}

	/*listUserThemes(userId){
		return this.afs.collection('themes', ref => ref.where('userId', '==', userId))
		.valueChanges({ idField: 'id' })
		.pipe(map(collection => {
			return collection.map(data => {
				let object = new Theme();
				object.fromJSON(data);
				return object;
			});
		}))
		.pipe(map(themes => themes.sort((a, b) => {
			if (a.name['fr'] > b.name['fr']) return 1;
			else if (a.name['fr'] < b.name['fr']) return -1;
			else return 0;
		})));		
	}*/

	listThemes(){
		return collectionData(query(collection(this.firestore, 'themes')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let theme = new Theme();
				theme.fromJSON(doc);
				return theme;
			});
		}));
	}

	getTheme(themeUid){
        //return this.afs.collection('themes').doc(`${themeUid}`).valueChanges();
		if(this.themeBase){
			return this.themeBase.filter(function( theme ) {return theme.id == themeUid})[0];
		}
		return null;
	}

	addTheme(theme) {
		return addDoc(collection(this.firestore, 'themes'), {...theme});
	}

	updateTheme(themeUid, data){
		return updateDoc(doc(this.firestore, `themes/${themeUid}`), data);
	}

	deleteTheme(themeUid) {
		return deleteDoc(doc(this.firestore, `themes/${themeUid}`));
	}

	listAllEpisodes(){
		return collectionData(query(collectionGroup(this.firestore, 'episodes')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let episode = new Episode();
				episode.fromJSON(doc);
				return episode;
			});
		}));
	}

	listEpisodes(themeUid){
		return collectionData(query(collection(this.firestore, `themes/${themeUid}/episodes`)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let episode = new Episode();
				episode.fromJSON(doc);
				return episode;
			});
		}))
		.pipe(map(episodes => episodes.sort((a, b) => {
			if (a.name['fr'] > b.name['fr']) return 1;
			else if (a.name['fr'] < b.name['fr']) return -1;
			else return 0;
		})));	
	}

	getEpisode(themeUid, episodeUid){
        return docData(doc(this.firestore, `themes/${themeUid}/episodes/${episodeUid}`));
	}

	getLocalEpisode(episodeId){
		if(this.episodeBase){
			return this.episodeBase.filter(function( episode ) {return episode.id == episodeId})[0];
		}
		return null;
	}

	addEpisode(themeUid, episode) {
		return addDoc(collection(this.firestore, `themes/${themeUid}/episodes`), {...episode});
	}

	updateEpisode(themeUid, episodeUid, data){
		return updateDoc(doc(this.firestore, `themes/${themeUid}/episodes/${episodeUid}`), data);
	}

	copyEpisode(episode, destThemeId) {
		console.log('Copy episode '+episode.id+' to theme '+destThemeId);
		let data = { ...episode };
		data.themeId = destThemeId;
		return setDoc(doc(this.firestore, `themes/${destThemeId}/episodes/${episode.id}`), data);
	}

	deleteEpisode(themeUid, episodeUid) {
		return deleteDoc(doc(this.firestore, `themes/${themeUid}/episodes/${episodeUid}`));
	}
}
